import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"right\"><defs><path d=\"M7.363 23L6 21.637 15.637 12 6 2.363 7.363 1 17.68 11.319a.963.963 0 010 1.362L7.363 23z\" id=\"right_a\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><mask id=\"right_b\" fill=\"#fff\"><use xlink:href=\"#right_a\" /></mask><use fill=\"#111\" fill-rule=\"nonzero\" xlink:href=\"#right_a\" /><g mask=\"url(#right_b)\" fill=\"#C41230\"><path d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/right.svg
// module id = 1013
// module chunks = 0